jQuery(document).ready(function ($) {
  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length != 0) {
      if (img.not('[alt]')) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (img.not('[alt]')) {
        img.attr('alt', '');
      }
    }
  });

  // breadcrumbs
  $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

  //View More for Directory
  $('.bio-content-toggle').click(function () {
    var $bio = $(this).parent();
    var $toggletext = $(this).children('.text');

    if ($bio.hasClass('expanded')) {
      $bio.removeClass('expanded');
      $toggletext.text("View More");
    } else {
      $bio.addClass('expanded');
      $toggletext.text("View Less");
    }
  });

  if ($('#gallery-content-center').length > 0) {
    var $grid = $('#gallery-content-center').isotope({
      // options
      itemSelector: '.item',
      layoutMode: 'fitRows'
    });

    $('.apply-portfolio-filters').on('click', function () {
      applyPortfolioFilters($grid);
    });

    $('.gallery-header-center-right-links.view-all').on('click', function () {
      $('#category_select').val('filter-select-one');
      $('#service_select').val('filter-select-one');
      $grid.isotope({ filter: '*' });
    });

    var service = new URLSearchParams(location.search).get('service');
    if (service && $('#service_select').length > 0) {
      $('#service_select').val('filter-' + service);
      applyPortfolioFilters($grid);
    }
  }

  if ($('#details-gallery-content-center').length > 0) {
    $('#details-gallery-content-center').magnificPopup({
      delegate: 'a.image',
      type: 'image',
      tLoading: 'Loading image #%curr%...',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function (item) {
          return item.el.attr('title');
        }
      }
    });
  }

});

function applyPortfolioFilters($grid) {
  var cat = '.' + $('#category_select').val();
  var serv = '.' + $('#service_select').val();
  var catExists = cat.indexOf('select-one') == -1;
  var servExists = serv.indexOf('select-one') == -1;

  //If Both Are Selected filter AND
  if (catExists && servExists) {
    $grid.isotope({ filter: cat + serv });
  }
  //If only category selected filter cat
  if (catExists && !(servExists)) {
    $grid.isotope({ filter: cat });
  }
  //If only service selected filter serv
  if (!(catExists) && servExists) {
    $grid.isotope({ filter: serv });
  }
}
//Tables
$('#main').responsiveTables();